import { render, staticRenderFns } from "./messages-2.vue?vue&type=template&id=fd41e0be&"
import script from "./messages-2.vue?vue&type=script&lang=js&"
export * from "./messages-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd41e0be')) {
      api.createRecord('fd41e0be', component.options)
    } else {
      api.reload('fd41e0be', component.options)
    }
    module.hot.accept("./messages-2.vue?vue&type=template&id=fd41e0be&", function () {
      api.rerender('fd41e0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/messages-2.vue"
export default component.exports